import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hidden", "buttonUse", "buttonSize"];
import styled, { css } from 'foundations-theming/utils';
import { StyledButton } from '../Button/PrivateButton';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const makeTriangle = (size, direction = 'down') => css(["border-color:transparent;border-style:solid;border-width:", "em;display:inline-block;vertical-align:middle;", " ", " ", " ", ""], size, direction === 'down' && css(["border-top-color:currentColor;margin-block-start:", "em;"], size), direction === 'up' && css(["border-bottom-color:currentColor;margin-block-start:", "em;"], -size), direction === 'left' && css(["border-right-color:currentColor;margin-inline-start:", "em;margin-block-start:", "em;"], -size / 2, -size / 2), direction === 'right' && css(["border-left-color:currentColor;margin-inline-start:", "em;margin-block-start:", "em;"], size / 2, -size / 2));
export const StyledCaret = styled.span.withConfig({
  displayName: "DropdownCaret__StyledCaret",
  componentId: "sc-1dlazcw-0"
})(["", " align-self:center;flex-shrink:0;", " ", " ", " ", " ", " ", " ", ""], () => makeTriangle(0.3125, 'down'), ({
  $buttonUse,
  theme
}) => {
  // If buttonUse is undefined or if it is one of the specified values,
  // inherit the color from the parent element
  const shouldInheritColor = !$buttonUse || ['primary', 'primary-on-dark', 'secondary', 'secondary-on-dark', 'tertiary', 'tertiary-on-dark', 'tertiary-light', 'danger', 'link-on-dark', 'form-on-dark'].includes($buttonUse);
  return css(["color:", ";margin-inline-start:", ";"], shouldInheritColor ? 'inherit' : theme.color['temp-do-not-use-fill-secondary-default'], theme.space['50']);
}, ({
  $buttonSize
}) => css(["", ""], $buttonSize === 'small' && css(["& ", "{border-width:", ";margin-block-start:", ";}"], StyledButton, ({
  theme
}) => theme.borderWidth['300'], ({
  theme
}) => theme.space['100'])), ({
  $buttonUse,
  theme
}) => $buttonUse === 'enclosed' && css(["margin-inline-start:", ";"], theme.space['100']), ({
  $buttonUse
}) => ($buttonUse === 'form' || $buttonUse === 'form-on-dark') && css(["border-width:0.375em;color:", ";"], ({
  theme
}) => theme.color['border-info-default']), ({
  $buttonUse
}) => ($buttonUse === 'link' || $buttonUse === 'transparent') && css(["margin-inline-start:", ";color:#7c98b6;"], ({
  theme
}) => theme.space['50']), ({
  $hidden
}) => $hidden && css(["visibility:hidden;"]), ({
  $cssStyles
}) => $cssStyles && $cssStyles);
export const DropdownCaret = _ref => {
  let {
      hidden = false,
      buttonUse,
      buttonSize
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledCaret, {
    $hidden: hidden,
    $buttonUse: buttonUse,
    $buttonSize: buttonSize,
    $cssStyles: cssStyles,
    "data-test-id": hidden ? 'dropdown-caret-hidden' : 'dropdown-caret'
  });
};